import React, { useContext, useEffect, useRef } from 'react'
import { FeedApi } from '../../../redux/api/FeedApi'
import ReactTimeAgo from 'react-timeago'
import { Scrollbars } from 'react-custom-scrollbars-2';
import './ActivityFeed.scss'
import { trimChar } from '../../../utils/utils';
import { Link, useNavigate } from 'react-router-dom';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import { PartialSpinny } from '../../Nav/Spinny';
import { IFeedItem } from '../../../types/Feed/IFeedItem';
import { Icon } from '@progress/kendo-react-common';
import { Offset, Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout';
import { RevUserContext, RevUserContextType } from '../../../context/UserContext';
import { HeaderOptions } from '../HeaderOptions';
import { MenuProps } from '../Contacts/ContactsMenu';
import { HeaderMenu } from './HeaderMenu';
import { Switch } from '@progress/kendo-react-inputs';
import { SettingsDialog } from './SettingsDialog';
import { ErrorBoundary } from '../../Common/ErrorBoundry';
import { IFeedResult } from '../../../types/Feed/IFeedResult';

export const ActivityFeed = (props: ToolProps) => {
    const navigate = useNavigate();
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const dispatch = useReduxDispatch();
    //const { FeedItems, LastId } = useReduxSelector(rev => rev.feed.feedItems)
    const [lastFeedId, setLastFeedId] = React.useState<number>();
    const { data } = FeedApi.useGetUserFeedQuery({ uid: profile.Uid, lastId: lastFeedId ? lastFeedId?.toString() : '' }, { pollingInterval: 20000, skip: !props.fullScreen });
    const [resetFeed] = FeedApi.useResetFeedMutation();
    //const [trigger, result] = FeedApi.useLazyGetUserFeedQuery({ pollingInterval: 20000 });
    const feedResult = props.feedResults || data;
    const [postAllAsRead, { isLoading }] = FeedApi.useClearFeedMutation();
    const [markAsRead, { isLoading: markingAsRead }] = FeedApi.useMarkAsReadMutation();
    const [markAsUnRead, { isLoading: markingAsUnRead }] = FeedApi.useMarkAsUnReadMutation();
    const [unreadOnly, setUnreadonly] = React.useState<boolean>(true);
    //const [autoRefresh, setAutoRefresh] = React.useState<boolean>(true);
    const [menuProps, setMenuProps] = React.useState<ItemMenuProps>();
    const [headerMenu, setHeaderMenu] = React.useState<MenuProps<HeaderOptions>>()
    const [settingsVisible, setSettingsVisible] = React.useState(false);
    //const [itemsToRender, setItemsToRender] = React.useState<IFeedItem[]>([]);
    // useEffect(() => {
    //     setLastFeedId(LastId)
    // }, [LastId])

    // useEffect(() => {
    //     console.log('run once');
    //     trigger({ uid: profile.Uid, lastId: lastFeedId ? lastFeedId?.toString() : '' })
    // }, [])

    //console.log('lastFeedId', lastFeedId, LastId)

    //Update the feed items in reduc state
    useEffect(() => {
        console.log('ActivityFeed useEffect', feedResult)
        if (feedResult && feedResult.LastId > 0 && feedResult.LastId !== lastFeedId)
            setLastFeedId(feedResult.LastId);
        //dispatch(FeedSlice.SetFeedItems(feedResult));

    }, [feedResult, dispatch])

    const markAllRead = async () => {
        await postAllAsRead(profile.Uid);
    }

    const feedItemClicked = async (f: IFeedItem) => {
        if (!f.Is_Read) {
            //setAutoRefresh(false);
            await markAsRead({ id: f.Feed_Item_Id, uid: profile.Uid });
        }
    }

    const handleContextMenu = (e, f: IFeedItem) => {
        e.preventDefault();

        setMenuProps({ offset: { left: e.clientX, top: e.clientY }, visible: true, isread: f.Is_Read || (f.Use_Temp_Read && f.Is_Temp_Read), id: f.Feed_Item_Id });
    };

    const menuItemSelected = async (e: MenuSelectEvent) => {
        //Mark the item as read / unread
        e.item.text.indexOf('Unread') > -1
            ? await markAsUnRead({ id: menuProps.id, uid: profile.Uid })
            : await markAsRead({ id: menuProps.id, uid: profile.Uid })

        setMenuProps(oldProps => { return { ...oldProps, visible: false } })
    }
    //Close the menu
    const feedClicked = () => setMenuProps(oldProps => { return { ...oldProps, visible: false } })

    const HeaderOptions = [
        {
            id: "settings",
            title: `Settings`,
            element: <button className='icon settings k-font-icon k-i-gear' title='Settings'></button>,
            onclick: () => setSettingsVisible(true),
            visible: true
        },
        {
            id: "read",
            title: `Mark all as Read`,
            //image: './images/clear_button_grey.png',
            element: <button className='icon settings k-font-icon k-i-eye' title='Open in New Window'></button>,
            onclick: markAllRead,
            visible: true
        },
        {
            id: "win",
            title: `Open in New Window`,
            //image: 'images/ibutton_revelations_popout_black.png',
            element: <button className='icon settings k-font-icon k-i-hyperlink-open' title='Open in New Window'></button>,
            link: '/Feed',
            visible: !props.fullScreen
        }, {
            id: "unread",
            title: ``,
            onclick: () => {
                setUnreadonly((u) => {
                    return !u
                });

                console.log('reset the feed Read state')
                //reset the feed Read state
                dispatch(
                    FeedApi.util.updateQueryData("getUserFeed", undefined, (draft) => {
                        console.log('updateQueryData', draft.FeedItems?.length)
                        draft.FeedItems.filter(f => f.Use_Temp_Read).map(f => {
                            console.log('reset the feed Read state', f)
                            f.Is_Read = f.Use_Temp_Read && f.Is_Temp_Read;
                            f.Use_Temp_Read = false;
                            f.Is_Temp_Read = false;
                        });
                    })
                );
            },
            element: <>Unread only <Switch defaultChecked={unreadOnly} /></>,
            visible: true
        },
    ] as HeaderOptions[]

    function rightBarMouseOut(e) {
        //console.log('Mouse out', e);

        props.itemSelected && props.itemSelected(e);
    }

    const headerRef = React.useRef<HTMLButtonElement>();

    const itemsToRender = feedResult?.FeedItems?.filter(f => !unreadOnly || !f.Is_Read);


    //Log to the console why this react component rerenders
    function useTraceUpdate(props) {
        const prev = useRef(props);
        useEffect(() => {
            const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
                if (prev.current[k] !== v) {
                    ps[k] = [prev.current[k], v];
                }
                return ps;
            }, {});
            if (Object.keys(changedProps).length > 0) {
                console.warn('ActivityFeed.tsx Changed props:', changedProps);
            }
            prev.current = props;
        });
    }

    if (!feedResult?.FeedItems)
        return <></>

    return (
        <ErrorBoundary errorMessage='Error: Failed to load component.'>
            <section className='feed' onClick={feedClicked} onMouseLeave={props.onMouseLeave}>
                <header className='right-bar-header'>
                    <img alt='feed' className='icon' src='./images/Activity-Feed-Dark.png' width='25' height='25' style={{ alignContent: 'center' }} />
                    <span className='text'>Activity Feed</span>
                    <button ref={headerRef} className='icon k-font-icon k-i-more-horizontal' title='More options' onClick={(e) => {
                        setHeaderMenu((m) => {
                            //console.log('headerRef.current', headerRef.current);
                            return { ...m, visible: !m?.visible, offset: { top: e.clientY + 30, left: e.clientX - 170 } }
                        })
                    }} />
                    {!props.fullScreen && <button className='icon lock' onClick={props.unlocked} title='Unlock side-bar' ><img src='./images/Lock.png' alt='lock contacts' style={{ alignContent: 'center' }} /></button>}
                    {!props.fullScreen && <button className='icon unlock' onClick={props.locked} title='Lock side-bar' ><img src='./images/Unlock.png' alt='unlock contacts' style={{ alignContent: 'center' }} /></button>}
                </header>
                {settingsVisible && <SettingsDialog onSaved={() => { setSettingsVisible(false) }} onClose={() => { setSettingsVisible(false) }} />}
                <HeaderMenu {...headerMenu} options={HeaderOptions.filter(o => o.visible)} itemClicked={() => setHeaderMenu(null)} />
                <Scrollbars autoHeight={false} autoHide={true}>
                    {(isLoading) && <PartialSpinny />}
                    <ul className='activityFeed'>
                        {itemsToRender?.map((f) => {
                            if (unreadOnly && f.Is_Read)
                                return <></>

                            var itemClass = f.Is_Read || (f.Use_Temp_Read && f.Is_Temp_Read) ? 'fi' : 'fi unReadFeedItem'
                            return (
                                <li className={itemClass} key={f.ID} onClick={() => feedItemClicked(f)} onContextMenu={(e) => handleContextMenu(e, f)}>
                                    <table className={`ft ${f.Call_State_CSS}`}>
                                        <tbody>
                                            {/* <tr style={{ verticalAlign: 'top' }}>
                                        <td></td>
                                        <td colSpan={2}><span className="feedName"><span className="feedTL">{f.Header}</span></span></td>
                                        <td className="tdFH"></td>
                                        <td align="right"><ReactTimeAgo date={new Date(f.Action_Date + 'Z')}></ReactTimeAgo>
                                        </td>
                                    </tr> */}
                                            <tr style={{ verticalAlign: 'top' }}>
                                                <td className="stateCell"><div></div></td>
                                                {/* {f.ShowProfileIMages && <td className="profileCell"><img className="feedImage" src={trimChar(f.ImageUrl, '~')} style={{ borderWidth: '0' }} /></td>} */}
                                                {/* always show profile image */}
                                                {f.ShowProfileIMages && <td className="profileCell">
                                                    <img className="feedImage" src={trimChar(f.ImageUrl ? f.ImageUrl : './images/placeholder.png', '~')} style={{ borderWidth: '0' }} alt='profile' />
                                                    {f.Activity_Image_Url && <img className="activity-image" src={'.' + trimChar(f.Activity_Image_Url, '~')} title={f.Header} style={{ borderWidth: '0' }} alt='activity type' />}
                                                </td>}
                                                <td colSpan={4}>
                                                    <table style={{ borderCollapse: 'separate' }} >
                                                        <tbody>
                                                            <tr style={{ verticalAlign: 'top' }}>
                                                                <td className='n'>{f.Action_Contact_Name}</td>
                                                                <td align="right" className='nw'>
                                                                    {/* timeStyle={{ labels: 'short', steps: null, round: 'round' }}  */}
                                                                    <div><ReactTimeAgo date={new Date(f.Action_Date + 'Z')} ></ReactTimeAgo></div>
                                                                    <Link title={`Add ${profile?.Phrases.Action}`} className='action-link' to={`/ticket/${f.Call_Id}/action`} target={props.fullScreen ? '_blank' : '_self'}><Icon name='plus'></Icon></Link>
                                                                    <Link title='View details' to={`/deeplink/?url=/calls/callhistory.aspx%3Fcall_id=${f.Call_Id}`} target={props.fullScreen ? '_blank' : '_self'} onClick={() => {
                                                                        //dispatch(RevelationSlice.updateIframeSrc(`/calls/callhistory.aspx?call_id=${f.Call_Id}`));
                                                                        //navigate(`/deeplink/?url=/calls/callhistory.aspx%3Fcall_id=${f.Call_Id}}`)
                                                                        props.itemSelected();
                                                                    }}>#{f.Call_Id}</Link>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2}>
                                                                    {/* HTMLEllipsis is WAAAAAY SLow for 100+ entries */}
                                                                    <div dangerouslySetInnerHTML={{ __html: f.Text }} ></div>
                                                                    {/* lines: {f.Text.indexOf('feedDesc1lines') > -1 ? 3 : f.Text.indexOf('feedDesc2lines') > -1 ? 4 : f.Text.indexOf('feedDesc3lines') > -1 ? 5 : 5} */}
                                                                    {/* <HTMLEllipsis

                                                                        unsafeHTML={f.Text}
                                                                        maxLine={f.Text.indexOf('feedDesc1lines') > -1 ? 3 : f.Text.indexOf('feedDesc2lines') > -1 ? 4 : f.Text.indexOf('feedDesc3lines') > -1 ? 5 : 5}
                                                                        ellipsis='...'
                                                                        basedOn=''
                                                                    /> */}
                                                                </td>
                                                            </tr>
                                                            {f.From_String && f.To_String &&
                                                                <>
                                                                    <tr style={{ verticalAlign: 'top' }}>
                                                                        <td colSpan={2}><span className="feedTL">{f.Header}</span></td>
                                                                    </tr>
                                                                    <tr style={{ verticalAlign: 'top' }}>
                                                                        <td colSpan={2}><span dangerouslySetInnerHTML={{ __html: f.From_String }}></span> <span className='k-font-icon k-i-arrow-right'></span> <span dangerouslySetInnerHTML={{ __html: f.To_String }}></span></td>
                                                                    </tr>
                                                                </>
                                                            }


                                                        </tbody></table>
                                                </td>

                                            </tr>
                                            <tr className="trAP">
                                                <td></td>
                                                <td className="r" colSpan={2}>
                                                </td>
                                            </tr>
                                        </tbody></table>

                                </li>
                            )
                        })}
                        {!feedResult?.FeedItems?.length
                            ? <li className='no-fi'>{!feedResult?.FeedItems ? 'Loading...' : `No activity to display`}</li>
                            : itemsToRender.length === 0 && <li className='no-read'><b>You don't have any unread activity</b>
                                <p className='mt-5'>You can us this toggle (also in the menu options) to toggle between read and unread items.</p>
                                <div className='mt-3'>Unread only <Switch defaultChecked={unreadOnly} onChange={() => setUnreadonly(u => !u)} /></div>
                            </li>}
                    </ul>
                </Scrollbars>
                {menuProps?.visible &&
                    <Popup show={menuProps?.visible} offset={menuProps?.offset} className='feed-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
                        <Menu vertical={true} style={{ display: "inline-block" }} onSelect={menuItemSelected} openOnClick={false} hoverCloseDelay={100} >
                            {menuProps?.isread
                                ? <MenuItem text="Mark as Unread" />
                                : <MenuItem text="Mark as Read" />
                            }
                        </Menu>
                    </Popup>
                }
            </section>
        </ErrorBoundary>
    )
}

export type ItemMenuProps = {
    id: number
    visible: boolean
    offset: Offset
    isread: boolean
}

export type ToolProps = {
    feedResults?: IFeedResult
    fullScreen: boolean
    unlocked?: () => void
    locked?: () => void
    itemSelected?: (e?: any) => void
    onMouseLeave?: (e?: any) => void
}